exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pair-list__error {\n  line-height: 1.2;\n  margin-top: .375rem;\n  font-size: .75rem;\n  color: var(--danger-color);\n  margin-top: var(--spacing-default);\n}\n", ""]);

// exports
